import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  loading = signal(false);
  currentTicketId = signal('');
}
